import { filterNonAstNodes } from '../parser';
import { nameLikeTokens } from '../parser/fns';
import { unreachable } from '../util/todo';
import { buildExpr } from './expr';
import { buildBool, buildChar, buildIdentifier, buildName, buildString } from './operand';
import { buildBlock } from './statement';
export const buildMatchExpr = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    // skip match-keyword
    idx++;
    const expr = buildExpr(nodes[idx++]);
    const clauses = filterNonAstNodes(nodes[idx++]).map(buildMatchClause);
    return { kind: 'match-expr', parseNode: node, expr, clauses };
};
export const buildMatchClause = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    const patterns = filterNonAstNodes(nodes[idx++]).map(c => buildPattern(c));
    const guard = nodes[idx].kind === 'guard' ? buildExpr(filterNonAstNodes(nodes[idx++])[1]) : undefined;
    const block = buildBlock(nodes[idx++]);
    return { kind: 'match-clause', parseNode: node, patterns, guard, block };
};
export const buildPattern = (node) => {
    const nodes = filterNonAstNodes(node);
    let idx = 0;
    const name = nodes[idx].kind === 'pattern-bind' ? buildName(filterNonAstNodes(nodes[idx++])[0]) : undefined;
    const expr = buildPatternExpr(nodes[idx++]);
    return { kind: 'pattern', parseNode: node, name, expr };
};
export const buildPatternExpr = (node) => {
    const n = filterNonAstNodes(node)[0];
    if (nameLikeTokens.includes(n.kind)) {
        return buildName(n);
    }
    switch (n.kind) {
        case 'name':
            return buildName(n);
        case 'con-pattern':
            return buildConPattern(n);
        case 'list-pattern':
            return buildListPattern(n);
        case 'hole':
            return buildHole(n);
        case 'number':
            return buildNumber(n);
        case 'string':
            return buildString(n);
        case 'char':
            return buildChar(n);
        case 'bool':
            return buildBool(n);
        default:
            return unreachable(n.kind);
    }
};
export const buildConPattern = (node) => {
    const nodes = filterNonAstNodes(node);
    const identifier = buildIdentifier(nodes[0]);
    const fieldPatterns = filterNonAstNodes(nodes[1]).map(buildFieldPattern);
    return { kind: 'con-pattern', parseNode: node, identifier, fieldPatterns };
};
export const buildListPattern = (node) => {
    const nodes = filterNonAstNodes(node);
    return { kind: 'list-pattern', parseNode: node, itemPatterns: nodes.map(buildPattern) };
};
export const buildFieldPattern = (node) => {
    const nodes = filterNonAstNodes(node);
    const name = buildName(nodes[0]);
    const pattern = nodes.at(1) ? buildPattern(nodes[1]) : undefined;
    return { kind: 'field-pattern', parseNode: node, name, pattern };
};
export const buildHole = (node) => {
    return { kind: 'hole', parseNode: node };
};
export const buildNumber = (node) => {
    const nodes = filterNonAstNodes(node);
    const n = nodes.at(-1);
    const sign = nodes[0].kind === 'minus' ? '-' : '';
    if (n.kind === 'int') {
        return { kind: 'int-literal', parseNode: node, value: sign + n.value };
    }
    if (n.kind === 'float') {
        return { kind: 'float-literal', parseNode: node, value: sign + n.value };
    }
    throw Error(`expected number, got ${node.kind}`);
};
//# sourceMappingURL=match.js.map